import { firebase } from "../script/Fetch";
import { IngredientePiatto } from "./IngredientePiatto";

export const IngredienteConverter = {
    toFirestore(ingrediente: Ingrediente): firebase.firestore.DocumentData {
        return {
            nome_ingrediente: ingrediente.nomeIngrediente,
            descrizione: ingrediente.descrizione,
            costoUnita: ingrediente.costoUnita,
            tipoUnita: ingrediente.tipoUnita,
            versione: ingrediente.versione,
            sotto_ingrediente_list: ingrediente.sottoIngredienteList,
            allergene_list: ingrediente.allergeneList
        };
    },
    fromFirestore(
        snapshot: firebase.firestore.QueryDocumentSnapshot,
        options: firebase.firestore.SnapshotOptions
    ): Ingrediente {
        const data = snapshot.data(options)!;
        return new Ingrediente(
            snapshot.id,
            data.nome_ingrediente,
            data.versione,
            data.descrizione,
            data.costo_unita,
            data.tipo_unita,
            data.sotto_ingrediente_list,
            data.allergene_list
        );
    }
};

export class Ingrediente {
    private _id: string;
    private _nomeIngrediente: string;
    private _descrizione: string;
    private _costoUnita: number;
    private _tipoUnita: string;
    private _sottoIngredienteList: IngredientePiatto[];
    private _allergeneList: number[];
    private _versione: string;

    constructor(id: string,
        nomeIngrediente: string,
        versione: string,
        descrizione: string,
        costoUnita: number,
        tipoUnita: string,
        sottoIngredienteList: IngredientePiatto[],
        allergeneList: number[]) {
        this._id = id;
        this._nomeIngrediente = nomeIngrediente;
        this._versione = versione;
        this._descrizione = descrizione;
        this._costoUnita = costoUnita;
        this._tipoUnita = tipoUnita;
        this._sottoIngredienteList = sottoIngredienteList;
        this._allergeneList = allergeneList;
    }

    static createEmpty(): Ingrediente {
        return new Ingrediente("", "", "1.0.0", "", 0, "", [], []);
    }

    
    static async convertFromFirestore(id: string, data: any) {
        return this.convertFromFirestoreWithPropagation(id, data, true);
    }

    static async convertFromFirestoreWithPropagation(id: string, data: any, propagateConvert: boolean) {
        let ingrediente = this.createEmpty();
        ingrediente.id = id;
        ingrediente.nomeIngrediente = data.nome_ingrediente;
        ingrediente.descrizione = data.descrizione;
        ingrediente.costoUnita = data.costo_unita;
        ingrediente.tipoUnita = data.tipo_unita;
        ingrediente.allergeneList = data.allergene_list;
        ingrediente.versione = data.versione;

        if(propagateConvert === true) {
            for(let sottoIngrediente of data.sotto_ingrediente_list) {
                ingrediente._sottoIngredienteList.push(await IngredientePiatto.convertFromFirestore(sottoIngrediente));
            }
        }

        return ingrediente;
    }

    convertToFirestore(): any {
        return {
            nome_ingrediente: this._nomeIngrediente,
            descrizione: this._descrizione,
            costo_unita: this._sottoIngredienteList.length !== 0 ? null : this._costoUnita,
            tipo_unita: this._tipoUnita,
            sotto_ingrediente_list: [],
            allergene_list: this._allergeneList,
            versione: this._versione
        };
    }

    get id(): string {
        return this._id;
    }

    set id(value: string) {
        this._id = value;
    }

    get nomeIngrediente(): string {
        return this._nomeIngrediente;
    }

    set nomeIngrediente(value: string) {
        this._nomeIngrediente = value;
    }

    get descrizione(): string {
        return this._descrizione;
    }

    set descrizione(value: string) {
        this._descrizione = value;
    }

    get costoUnita(): number {
        return this._costoUnita;
    }

    set costoUnita(value: number) {
        this._costoUnita = value;
    }

    get tipoUnita(): string {
        return this._tipoUnita;
    }

    set tipoUnita(value: string) {
        this._tipoUnita = value;
    }

    get sottoIngredienteList(): IngredientePiatto[] {
        return this._sottoIngredienteList;
    }

    set sottoIngredienteList(value: IngredientePiatto[]) {
        this._sottoIngredienteList = value;
    }

    get allergeneList(): number[] {
        return this._allergeneList;
    }

    set allergeneList(value: number[]) {
        this._allergeneList = value;
    }

    get versione(): string {
        return this._versione;
    }

    set versione(value: string) {
        this._versione = value;
    }
}